import { BaseFormFieldProps } from "models/propTypes/wintFormPropsTypes";
import { UtilsHelper } from "utils/helpers";

const unconnectedFormField: Readonly<BaseFormFieldProps> = {
  name: "",
  value: undefined,
  onChange: UtilsHelper.emptyFunc,
  onBlur: UtilsHelper.emptyFunc,
  setValue: UtilsHelper.emptyFunc,
  setTouched: UtilsHelper.emptyFunc,
  touched: false,
  error: undefined,
  hasError: false,
};

export default unconnectedFormField;
